import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { theme } from '@flos/react-components';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { useStateValue } from '../../hooks/UseStateValue';
import { OnsaHeader } from '../../components/onsa-header/onsa-header';

import { IProps } from '../../interfaces/IProps';

import RouterApp from './../../router/RouterApp';
import { ErrorBoundary } from '../../containers/ErrorBoundary/ErrorBoundary';
import { ProgressBar } from '../../components/shared/ProgressBar/ProgressBar';
import OnsaBanner from '../../components/shared/OnsaBanner/OnsaBanner';

export const FormContainer = (props: IProps) => {
  const { pathname } = useLocation();
  const [{ actualStep, packagesDetails, bannerText, overlayText }] = useStateValue();

  const shouldShowBanner = useMemo(
    () => packagesDetails?.hasProductDiscount && pathname === '/pakker',
    [pathname, packagesDetails?.hasProductDiscount]
  );
  const shouldShowProgressBar = useMemo(
    () => props.pageType === 'app' && actualStep >= 3 && actualStep <= 10,
    [actualStep, props.pageType]
  );

  return (
    <div className="onsa-main-wrapper">
      <OnsaHeader />
      {shouldShowBanner && <OnsaBanner variant="top" body={bannerText} enableToggle={!!overlayText} />}
      <div className="onsa-content-area">
        {shouldShowProgressBar && (
          <div className="progress-bar-wrapper">
            <div role="progressbar" className="progress-bar-inner-wrapper">
              <ProgressBar {...props} />
            </div>
          </div>
        )}
        <Container fixed>
          <MuiThemeProvider theme={theme}>
            <div className="onsa-main-inner-wrapper">
              <RouterApp basename={props.basename || '/'} props={props}>
                <ErrorBoundary {...props} />
              </RouterApp>
            </div>
          </MuiThemeProvider>
        </Container>
      </div>
    </div>
  );
};
